var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMediaSubscriptions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Smart-Tv-App--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Smart Tv App Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.47 10.43a0.65 0.65 0 0 0 0.19 0 0.51 0.51 0 0 0 0.35 -0.15l1.26 -1.25a0.54 0.54 0 0 0 0.14 -0.36 0.51 0.51 0 0 0 -0.15 -0.36L19 7.17a0.49 0.49 0 0 0 -0.54 -0.1 0.51 0.51 0 0 0 -0.3 0.46V10a0.5 0.5 0 0 0 0.31 0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29 7.07a0.49 0.49 0 0 0 -0.54 0.1L3.5 8.35a0.48 0.48 0 0 0 -0.16 0.36 0.51 0.51 0 0 0 0.15 0.36l1.25 1.25a0.53 0.53 0 0 0 0.35 0.15 0.71 0.71 0 0 0 0.2 0 0.51 0.51 0 0 0 0.3 -0.46V7.53a0.49 0.49 0 0 0 -0.3 -0.46Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0h-21A1.5 1.5 0 0 0 0 1.5V18a1.5 1.5 0 0 0 1.5 1.5h9.25a0.25 0.25 0 0 1 0.25 0.25v2a0.25 0.25 0 0 1 -0.25 0.25H7.5a1 1 0 0 0 0 2h9a1 1 0 0 0 0 -2h-3.25a0.25 0.25 0 0 1 -0.25 -0.25v-2a0.25 0.25 0 0 1 0.25 -0.25h9.25A1.5 1.5 0 0 0 24 18V1.5A1.5 1.5 0 0 0 22.5 0ZM2 5.25h5.56v6.88H2ZM22 15a0.5 0.5 0 0 1 -0.5 0.5h-19A0.5 0.5 0 0 1 2 15v-1.37h20ZM9.06 12.13V5.25h5.64v6.88Zm12.94 0h-5.8V5.25H22Zm0 -8.38H2V2.5a0.5 0.5 0 0 1 0.5 -0.5h19a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMediaSubscriptions);
export default ForwardRef;